import {Component, Input, OnInit} from '@angular/core';
@Component({
    selector: 'app-risk-assessment-card',
    templateUrl: './risk-assessment-card.component.html',
    styleUrls: ['./risk-assessment-card.component.scss'],
    standalone: false
})
export class RiskAssessmentCardComponent implements OnInit {
    @Input() tag: string = '';
    constructor() {
    }
    ngOnInit() {
    }

}
